// extracted by mini-css-extract-plugin
module.exports = {"container":"KimGroup_container__1mIgd","frame":"KimGroup_frame__2SwvQ","spin":"KimGroup_spin__28nvV"};